<template>
  <div class="d-flex align-items-center flex-row flex-lg-column step-container">
    <div class="d-flex align-items-center">
      <hr class="step-line line-border-darkgrey" :class="{'invisible': first}">
      <div 
      :class="circleStyle"
      class="d-flex justify-content-center align-items-center rounded-circle m-1 m-md-2 text-center align-middle step-circle"
      >
        <span v-html="label" class="step-label d-none d-lg-flex"></span>
      </div>
      <hr class="step-line line-border-darkgrey" :class="{'invisible' : last}">
    </div>
    <div 
      :class="textStyle"
      class="text-uppercase d-none d-lg-flex"><small><b>{{caption}}</b></small></div>
  </div>
</template>

<script>
export default {
  name: 'SteppedProgressItem',
  props: ['state', 'label', 'caption', 'first', 'last'],
  computed: {
    circleStyle: function () {
      switch(this.state) {
        case 'active':
          return 'bg-saka-orange text-white border-saka-orange'
        case 'configured':
          return 'bg-darkgrey text-white border-darkgrey'
        default:
          return 'bg-transparent text-darkgrey border-darkgrey'
      }
    },
    textStyle: function () {
      switch(this.state) {
        case 'active':
          return 'text-saka-orange'
        default:
          return 'text-darkgrey'
      }
    }
  }
}
</script>

<style lang="scss">
.border-darkgrey {
  border: 2px solid $darker-eee;
}

.line-border-darkgrey {
  border: 1px solid $darker-eee;
}

.step > span {
  font-weight: 600;
}

.step-label {
  font-weight: bold;
}

@media (min-width: 769px) {
  .step-container {
    min-width: 80px;
  }

  .step-line {
    min-width: 30px;
  }

  .step-circle {
    height: 2em;
    width: 2em;
  }
}

@media (max-width: 768px) {
  .step-line {
    max-width: 25px;
    min-width: 10px;
  }

  .step-container {
    max-width: 90px;
  }

  .step-circle {
    height: 1.5rem;
    width: 1.5rem;
  }
}

@media (max-width: 462px) {
  .step-line {
    max-width: 18px;
    min-width: 5px;
  }

  .step-container {
    max-width: 45px;
  }

  .step-circle {
    height: 1rem;
    width: 1rem;
  }
}
</style>